import React, { useState, useEffect } from "react";
import {
  Typography,
  Box,
  Tabs,
  Tab,
} from "@mui/material";

import VendorTimings from "./VendorTimings";
import VendorRoles from "./VendorRoles";
import NotificationSettings from "./NotificationSettings";
import PaymentBankingSettings from "./PaymentBankingSettings";
import UserManagement from "./UserManagement";
import { VendorappBar } from "../../../components";
import { useSelector } from "react-redux";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const SettingsPage = ({ onBackScreenName }) => {
  const [value, setValue] = useState(0);
  const userDetails = useSelector((state) => state.user.userdetails);
  const userVtype = userDetails?.vtype;
  const isVlistUser = userVtype === "vlistuser";

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleScreeName = (sname) => {
    onBackScreenName(sname);
  };

  useEffect(() => {
    setValue(0);
  }, [isVlistUser]);

  // Tabs for vlistuser
  const vlistTabs = [
    { label: "Timings", content: <VendorTimings /> },
  ];

  // Tabs for regular vendor
  const regularTabs = [
    { label: "Notification", content: <NotificationSettings /> },
    { label: "Timings", content: <VendorTimings /> },
    { label: "Roles", content: <VendorRoles /> },
    { label: "User", content: <UserManagement /> },
    { label: "Payment & Banking Settings", content: <PaymentBankingSettings /> },
  ];

  const tabsToRender = isVlistUser ? vlistTabs : regularTabs;

  return (
    <Box sx={{ display: "flex" }}>
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "#EEF2FF",
          p: 3,
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          height: "100vh",
          "&::-webkit-scrollbar": { display: "none" },
          msOverflowStyle: "none",
          scrollbarWidth: "none",
        }}
      >
        <VendorappBar
          title={"Settings & Configuration"}
          onBackScreenName={handleScreeName}
        />

        <Tabs value={value} onChange={handleChange} aria-label="settings tabs">
          {tabsToRender.map((tab, index) => (
            <Tab
              key={index}
              label={tab.label}
              sx={{ textTransform: "none" }}
            />
          ))}
        </Tabs>

        {tabsToRender.map((tab, index) => (
          <TabPanel key={index} value={value} index={index}>
            {tab.content}
          </TabPanel>
        ))}
      </Box>
    </Box>
  );
};

export default SettingsPage;
